import Vue from 'vue'
import { mapActions } from 'vuex'

export const mixin = {
  methods: mapActions(['showSpinner', 'hideSpinner', 'showToast'])
}

Vue.mixin(mixin)
